<template>
    <div style="height: calc(100vh - 360px);overflow-y: auto;">
        <div v-for="(item, index) in voteSubjectList" class="voteSubjectListWrap">
            <div class="voteSubjectList">
                {{ index+1 }}.{{ item.subjectTitle }}
                【 
                {{ item.subjectType == 'radio' ? '单选题' : '' }}
                {{ item.subjectType == 'checkbox' ? '多选题' : '' }}
                {{ item.subjectType == 'question' ? '问答题' : '' }}
                】
            </div>
            <div>
                <span v-for="(item1, index1) in item.voteResultList" class="voteSubjectQuestion">
                    选项{{ index1+1 }}： &nbsp;&nbsp;
                    {{ item1.resultContent }}
                </span>
                <div v-if="item.subjectType == 'question'" style="padding: 3px;"><br></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        voteSubjectList: {
            type:Array,
            required: true
        },
    },
    data() {
        return {
            
        }
    },
    mounted (){
    },
    methods: {
    },
};
</script>
<style lang="less">
    .voteSubjectListWrap{
        padding: 12px;
    }
    .voteSubjectList{
        font-size: 14px;
        font-weight: bold;
    }
    .voteSubjectQuestion{
        display: inline-block;
        padding: 10px 10px;
    }
</style>